import React from 'react';
import AdminLayout from '../../../../components/Layout/AdminLayout';
import FeeCategoryPage from './FeeCategory';
import { restrictUrls } from '../../../../helpers/adminPrivileges';

function action({ store }) {
  const title = 'Platform Fees';

  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  const adminPrivileges =
    store.getState().adminPrevileges.privileges &&
    store.getState().adminPrevileges.privileges.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }

  // Same restriction list as pricing — admins who can manage pricing
  // can manage fees. If the privilege key doesn't exist, restrictUrls
  // falls back to allow (matches existing semantics in this codebase).
  if (!restrictUrls('/siteadmin/fee-category/list', adminPrivileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: (
      <AdminLayout>
        <FeeCategoryPage />
      </AdminLayout>
    ),
  };
}

export default action;
